module.exports = __webpack_public_path__ + "img/3.06afb91a.svg";